import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getTokens } from "@/utils/token";
import { useCurrentSession } from "@/hooks/useSession";
import { useEffect } from "react";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { access: accessToken } = getTokens();
  const sessionStarted = localStorage.getItem("sessionStarted");

  // فحص حالة الجلسة من الباك اند
  const { data: sessionData, isLoading: isLoadingSession } =
    useCurrentSession();

  // تحويل محكوم: إذا كانت الجلسة مغلقة/غير موجودة ولدينا توكن، وأنت لست في صفحة البدء → الذهاب لبدء الجلسة بدل تسجيل الخروج
  useEffect(() => {
    const noActive = !sessionData || !!sessionData?.ended_at;
    if (
      !isLoadingSession &&
      accessToken &&
      noActive &&
      location.pathname !== "/start-session"
    ) {
      navigate("/start-session", { replace: true });
    }
  }, [isLoadingSession, sessionData, accessToken, location.pathname, navigate]);

  if (!accessToken) {
    return <Navigate to='/login' replace />;
  }

  // إظهار شاشة الفحص فقط في التحميل الأولي (وليس أثناء إعادة الجلب الخلفية)
  if (isLoadingSession && !sessionData) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <div className='text-center'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4'></div>
          <p className='text-gray-600'>جاري فحص الجلسة...</p>
        </div>
      </div>
    );
  }

  // إن كانت هناك جلسة نشطة من الباك، ندخل مباشرة ونثبت sessionStarted محلياً
  if (sessionData && !sessionData.ended_at) {
    if (!sessionStarted) {
      localStorage.setItem("sessionStarted", "true");
      localStorage.setItem("sessionStartedAt", String(Date.now()));
    }
    return children;
  }

  // السماح بعرض صفحة بدء الجلسة فقط إذا كنا عليها فعلاً
  if (location.pathname === "/start-session") {
    return children;
  }

  // إن لم توجد جلسة نشطة وباقي الصفحات محمية → توجيه إلى البدء
  return <Navigate to='/start-session' replace />;
};

export default PrivateRoute;
